import React from 'react';
import './theme/variables.css';
import './theme/global.css';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ActivePageProvider } from './contexts/ActivePageContext';

import Login from '../src/pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Error404 from '../src/pages/404/404';
import LoginCallback from './pages/Login/LoginCallback';

import SmartRedirect from '../src/components/SmartRedirect';
import PrivateRoute from '../src/components/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<SmartRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
               <ActivePageProvider>
                  <Dashboard />
               </ActivePageProvider>
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
